import { render, staticRenderFns } from "./ListaComAnexoFallback.vue?vue&type=template&id=16e7cdd3&"
import script from "./ListaComAnexoFallback.vue?vue&type=script&lang=js&"
export * from "./ListaComAnexoFallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/williamsalmeida/www/hubcompras/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('16e7cdd3')) {
      api.createRecord('16e7cdd3', component.options)
    } else {
      api.reload('16e7cdd3', component.options)
    }
    module.hot.accept("./ListaComAnexoFallback.vue?vue&type=template&id=16e7cdd3&", function () {
      api.rerender('16e7cdd3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/anexos/ListaComAnexoFallback.vue"
export default component.exports